<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Asignación De Condición General Y Cláusula
            <!-- <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="onNuevo">Nuevo</v-btn>
            <ModalCondicionParticularComponent :listGeneral="listGeneral" /> -->
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Aseguradora *" color="textbox" v-model="objConSearch.idAseguradora"
                        :items="listGeneral.listAseguradora" item-text="aseguradora" item-value="idAseguradora"
                        @change="onListarPoliza($event,true)" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Póliza *" color="textbox" v-model="objConSearch.idPoliza"
                        :items="listGeneral.listPoliza" item-text="poliza" item-value="id_poliza"
                        @change="onListarProducto($event,true)" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Producto *" color="textbox" v-model="objConSearch.idProducto"
                        :items="listGeneral.listProducto" item-text="nombre_producto" item-value="id_producto"
                        @change="onListarClasificacionProducto($event,true); onListarAsignacionCondicionGeneral($event,true)"
                        outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Seguro" color="textbox" :placeholder="objConSearch.seguro" filled dense readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Naturaleza" color="textbox" :placeholder="objConSearch.naturaleza" filled dense readonly />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Regulación" color="textbox" :placeholder="objConSearch.regulacion" filled dense readonly />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4"></v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Tipo de Condiciones *" color="textbox" v-model="objConSearch.idTipoCondicion"
                        :items="listGeneral.listTipoCondicion" item-text="tipoCondicion" item-value="idTipoCondicion"
                        @change="onListarAsignacionCondicionGeneral($event,true)" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado *" color="textbox" v-model="objConSearch.idEstado"
                        :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado"
                        @change="onListarCondicionParticular($event,true)" outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-btn rounded dark v-show="_.size(listGeneral.detalle) > 0" color="primary" @click="insertarActualizar" v-html="'Guardar'"/>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" prepend-inner-icon="search" dense v-model="objConSearch.search" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :search="objConSearch.search" :headers="listGeneral.cabecera"
                        :items="listGeneral.detalle" class="elevation-3">

                        <template v-slot:item.activo="{ item }">
                            <v-checkbox color="textbox" v-model="item.estado" class="mt-3"/>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="objConSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'AsignacionCondicionGeneralYClausulaView',
        data: () => ({
            objConSearch: {},
            objConForm: {},
            listGeneral: [],
            listParametros: {},
        }),
        created() {
            axios.post(`${BASE_URI}administrador/asignacion-condicion-general-clausula/cargaGeneral`, {})
                .then((r) => {
                    if (_.get(r, ['data', 'existeError'], true)) mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) _.get(r, ['data', 'mensaje'], mensajeEstandar
                        .errorPeticion);
                    this.listGeneral = r.data.data.listas;
                    this.listParametros = r.data.data.listParametros;
                    this.objConSearch   = { 
                                    idEstado       : _.toString(this.listParametros.idEstadoDefault), 
                                    idAseguradora  : this.listGeneral.listAseguradora[0].idAseguradora,
                                    idTipoCondicion: _.toString(this.listGeneral.listTipoCondicion[0].idTipoCondicion)
                              };
                    this.objConForm     = {};
                    this.cargaGeneral();
                })
        },
        methods: {
            apiSend(url, objeto) {
                return axios.post(`${BASE_URI}${url}`, objeto);
            },
            cargaGeneral() {
                this.onListarPoliza('L',false,true)
                .then((r) =>{
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        return this.onListarProducto('L',false,true);
                })
                .then((r) =>{
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        return this.onListarClasificacionProducto('L',false);
                })
                .then((r) =>{
                    if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        return this.onListarAsignacionCondicionGeneral('L',false);
                })
                .catch((e) => {
                    mensajesAlerta(e, 'E');
                });
            },
            onListarPoliza(event, isActive = false, nuevo = false) {
                if (!_.isUndefined(event)) {
                    var objeto = _.merge({}, { opcion: 'LISTAR' }, _.pick(this.objConSearch, ['idAseguradora', 'idEstado']));
                    this.getSetData(this.objConSearch,['idPoliza','idProducto','seguro','naturaleza','regulacion'],null);
                    this.listGeneral.detalle = [];

                    var p = this.apiSend('administrador/poliza/listar',objeto)
                            .then((r) => {
                                if(r.status != 200) throw mensajeEstandar.errorPeticion;
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data'],[])) > 0){
                                        this.$set(this.listGeneral,'listPoliza',r.data.data);
                                        if(nuevo)
                                            this.$set(this.objConSearch,'idPoliza',this.listGeneral.listPoliza[0].id_poliza);
                                    }else if(isActive)
                                        mensajesAlerta(r.data.mensaje, 'I');
                                return r;
                            });
                
                    if(isActive)
                        p.catch((e) => { mensajesAlerta(e, 'E'); });

                    return p;
                }
            },
            onListarProducto(event,isActive = false,nuevo = false){
                if(!_.isUndefined(event)){
                    var objeto = _.merge({}, { opcion: 'L_COMBO' }, _.pick(this.objConSearch, ['idAseguradora','idPoliza','idEstado']));                   
                    this.getSetData(this.objConSearch,['idProducto','seguro','naturaleza','regulacion'],null);                    
                    this.listGeneral.detalle = [];

                    var p = this.apiSend('administrador/producto/listar',objeto)
                                .then((r) => {
                                    if(r.status != 200) throw mensajeEstandar.errorPeticion;
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                        if(_.size(_.get(r,['data','data'],[])) > 0){
                                            this.$set(this.listGeneral,'listProducto',r.data.data);
                                            if(nuevo)
                                                this.$set(this.objConSearch,'idProducto',r.data.data[0].id_producto);
                                        }else if(isActive)
                                            mensajesAlerta(r.data.mensaje, 'I');
                                    return r;
                                });
                    
                    if(isActive)
                        p.catch((e) => { mensajesAlerta(e, 'E'); });

                    return p;
                }
            },
            onListarClasificacionProducto(event, isActive) {
                if(!_.isUndefined(event)){
                    this.getSetData(this.objConSearch,['seguro','naturaleza','regulacion'],null);
                    this.listGeneral.detalle = [];

                    var p = this.apiSend('administrador/producto/listar',{opcion: 'DETALLE',idProducto: _.get(this.objConSearch,'idProducto',null)})
                                .then((r) => {
                                    if(r.status != 200) throw mensajeEstandar.errorPeticion;
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                        if(_.size(_.get(r,['data','data'],[])) > 0){
                                            this.objConSearch = _.merge({},this.objConSearch,r.data.data[0]);
                                        }else if(isActive)
                                            mensajesAlerta(r.data.mensaje, 'I');
                                    return r;
                                });

                    if(isActive)
                        p.catch((e) => { mensajesAlerta(e, 'E'); });

                    return p;
                }
            },
            onListarAsignacionCondicionGeneral(event,isActive = false){
                if(!_.isUndefined(event)){
                    var objeto =  _.merge({},{opcion : 'LISTAR'},_.pick(this.objConSearch,['idProducto','idTipoCondicion','idEstado']));
                    this.$set(this.listGeneral,'detalle',[]);

                    var p = this.apiSend('administrador/asignacion-condicion-general-clausula/listar',objeto)
                                .then((r) => {
                                    if(r.status != 200) throw mensajeEstandar.errorPeticion;
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                        if(_.size(_.get(r,['data','data'],[])) > 0){
                                            var l = _.map(r.data.data,(v) => {  v.index = _.uniqueId(); v.estado = v.estado == 1 ? true : false; return v; });
                                            this.$set(this.listGeneral,'detalle',l);
                                        }
                                        else if(isActive)
                                            mensajesAlerta(r.data.mensaje, 'I');
                                    return r;
                                });
                    
                    if(isActive)
                        p.catch((e) => { mensajesAlerta(e, 'E'); });

                    return p;
                }
            },
            getSetData(objeto,arrayKey,value){
                _.forEach(arrayKey,(v) => {
                    this.$set(objeto,v,value);
                });
            },
            insertarActualizar(){
                this.apiSend('administrador/asignacion-condicion-general-clausula/insertOrUpdate',{opcion: 'UM' ,listDetalle: this.listGeneral.detalle})
                    .then((r) => {
                        if(r.status != 200) throw mensajeEstandar.errorPeticion;
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            mensajeAlertaTiempo(r.data.mensaje,'S');
                            return this.onListarAsignacionCondicionGeneral('L');
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    })
            }
        }
    }
</script>